import {Row, Col} from 'react-bootstrap'
import deleteButton from '../../../../_metronic/images/deleteButton.svg'
import {alert} from '../../../../utils/helper'
import {IUtility} from './InterfaceProductSetup'
interface utilityProps {
  id: string
  value: string
  utilityDunsNumber: string
  utilitySubmitDays: string
  utilityShortName: string
  utilityPhoneNumber: string
  setUtilityData: any
  uanValidation: any
  errors: any
  readonly: boolean
  setDeletedId: any
  deletedId: any
  utilities: Array<any>
  setErrors: any
}

export default function Utility({
  id,
  value,
  utilityDunsNumber,
  utilitySubmitDays,
  setUtilityData,
  utilityShortName,
  utilityPhoneNumber,
  uanValidation,
  errors,
  readonly,
  setDeletedId,
  deletedId,
  utilities,
  setErrors,
}: utilityProps) {
  const handleValueChange = (property: any, changedValue: any) => {
    setUtilityData((prev: Array<IUtility>) =>
      prev.map((utility: any) => {
        if (utility.id === id) {
          utility[property] = changedValue
          return utility
        }
        return utility
      })
    )
    setErrors({})
  }
  const validateUtility = (changedValue: any) => {
    if (readonly === undefined && utilities?.includes(changedValue.toLowerCase())) {
      setUtilityData((prev: any) =>
        prev.map((utility: any) => {
          if (utility.id === id) {
            utility['value'] = ''
            return utility
          }
          return utility
        })
      )
      alert('Utility Already Exists', 'warning')
    }
  }
  return (
    <Row className='g-5 mb-7 align-items-center py-7 px-5 custom-box-shadow mt-3 position-relative'>
      <Col lg={2} className='mb-2 mt-0'>
        <label className='mb-2 fw-semibold required'>Utility</label>
        <input
          type='text'
          className='form-control form-control-lg form-control-solid'
          value={value === undefined ? '' : value}
          placeholder='Enter utility'
          readOnly={readonly}
          onChange={(e) => {
            handleValueChange('value', e.target.value)
          }}
          onBlur={() => validateUtility(value)}
        />
        {errors[id]?.utility && (
          <div className='fv-plugins-message-container'>
            <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
              Utility is required
            </div>
          </div>
        )}
      </Col>
      <Col lg={2} className='mb-2 mt-0'>
        <label className='mb-2 fw-semibold required'>
          Utility Pronunciation{' '}
          <i
            className='bi bi-info-circle ms-2 text-primary cursor-pointer'
            onClick={() => alert('Pronunciation for Utility name in scripts', 'info')}
          ></i>
        </label>
        <input
          type='text'
          className='form-control form-control-lg form-control-solid'
          value={Boolean(utilityShortName) ? utilityShortName : ''}
          placeholder='Enter pronunciation'
          onChange={(e) => {
            handleValueChange('utilityShortName', e.target.value)
          }}
          onBlur={() => validateUtility(value)}
        />
        {errors[id]?.shortName && (
          <div className='fv-plugins-message-container'>
            <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
              Pronunciation is required
            </div>
          </div>
        )}
      </Col>
      <Col lg={2} className='mb-2 mt-0'>
        <label className='mb-2 fw-semibold required'>DUNS Number</label>
        <input
          type='text'
          className='form-control form-control-lg form-control-solid'
          placeholder='Enter DUNS number'
          value={utilityDunsNumber}
          onChange={(e) => handleValueChange('utilityDunsNumber', e.target.value)}
        />
        {errors[id]?.dunsNumber && (
          <div className='fv-plugins-message-container'>
            <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
              DUNS number is required
            </div>
          </div>
        )}
      </Col>
      <Col lg={2} className='mb-2  mt-0'>
        <label className='fw-semibold mb-2'>
          Submit Days
          <i
            className='bi bi-info-circle ms-2 text-primary cursor-pointer'
            onClick={() => alert('Submit Date would be TPV Date + Days added', 'info')}
          ></i>
        </label>
        <input
          type='string'
          className='form-control form-control-lg form-control-solid'
          value={utilitySubmitDays}
          min={1}
          step={1}
          placeholder='Enter Days'
          onChange={(e) => {
            handleValueChange('utilitySubmitDays', e.target.value.replace('.', '').replace("+","").replace("-",""))
          }}
        />
      </Col>
      <Col lg={2} className='mb-2  mt-0 '>
        <label className='mb-2 fw-semibold'>Utility Phone Number</label>
        <div className='d-flex p-relative'>
          <div className='d-flex p-relative'>
            <input
              type='text'
              value='+1'
              className='form-control form-control-lg form-control-solid d-inline'
              disabled
              style={{
                width: '25px',
                padding: '0px',
                borderTopRightRadius: '0px',
                borderBottomRightRadius: '0px',
                fontSize: '14px',
              }}
            />
            <input
              type='number'
              maxLength={10}
              className='form-control form-control-lg form-control-solid p-3 d-inline'
              name='utilityPhoneNumber'
              placeholder='Enter phone number'
              value={Boolean(utilityPhoneNumber) ? utilityPhoneNumber : ''}
              pattern='[0-9]*'
              onChange={(e) =>
                e.target.value.length < 11 &&
                handleValueChange('utilityPhoneNumber', e.target.value)
              }
            />
          </div>
        </div>
        {errors[id]?.invalidPhoneNumber && (
          <div className='fv-plugins-message-container'>
            <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
              Invalid Phone number
            </div>
          </div>
        )}
      </Col>
      <Col lg={2} className='mb-2 mt-0'>
        <label className='fw-semibold mb-2'>
          UAN Validation
          <i
            className='bi bi-info-circle ms-2 text-primary cursor-pointer'
            onClick={() =>
              alert('Helps ensure Utility Account Number has specified number of digits', 'info')
            }
          ></i>
        </label>
        <input
          type='string'
          className='form-control form-control-lg form-control-solid d-inline'
          name='utilityPhoneNumber'
          placeholder='Enter UAN digits'
          value={Boolean(uanValidation) ? uanValidation : ''}
          onChange={(e) => {
            handleValueChange('uanValidation', e.target.value.replace(/[+\-]/g, ''))
          }}
        />
      </Col>
      <button
        className='btn btn-icon align-self-end ms-4'
        disabled={readonly}
        onClick={(e) => {
          setUtilityData((prev: any) => prev.filter((utility: any) => utility.id !== id))
          if (readonly !== undefined) {
            setDeletedId([...deletedId, id])
          }
        }}
        style={{
          position: 'absolute',
          right: 0,
          top: '-17px',
        }}
      >
        <img src={deleteButton} alt='delete' />
      </button>
    </Row>
  )
}
